import { render } from "./Bc.vue?vue&type=template&id=6f587539&scoped=true"
import script from "./Bc.vue?vue&type=script&lang=js"
export * from "./Bc.vue?vue&type=script&lang=js"

import "./Bc.vue?vue&type=style&index=0&id=6f587539&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f587539"]])

export default __exports__